<template>
  <div>
    <div class="max-w-7xl mx-auto sm:px-2 lg:px-8 pb-12 hidden">
      <CentralHeader title="Chat" />
      <topic-table></topic-table>
      <div>
        <div class=" mt-8 ">
          <if-can-take-part>
            <div
              class="max-w-screen-xl mx-auto text-center py-8 px-4 sm:px-6 lg:py-8 lg:px-8"
            >
              <div class="flex justify-center">
                <div class="inline-flex rounded-md shadow">
                  <button @click="toggleModal" class="standard-btn">
                    Suggest a New Topic
                  </button>
                </div>
              </div>
            </div>
          </if-can-take-part>
        </div>
      </div>
      <transition
        enter-active-class="ease-out duration-300"
        enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        enter-to-class="opacity-100 translate-y-0 sm:scale-100"
        leave-active-class="ease-in duration-200"
        leave-class="opacity-100 translate-y-0 sm:scale-100"
        leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      >
        <new-topic-modal
          v-if="showNewTopicModal"
          v-on:topic-added="toggleModal"
        />
      </transition>
    </div>
  </div>
</template>

<script>
window.location.href = "/";
import TopicTable from "./TopicTable";
import NewTopicModal from "./NewTopicModal";
import { mapGetters } from "vuex";
import CentralHeader from "./shared/CentralHeader";
import IfCanTakePart from "./IfCanTakePart.vue";
export default {
  name: "TopicView",
  components: { IfCanTakePart, CentralHeader, NewTopicModal, TopicTable },
  data() {
    return {
      showNewTopicModal: false
    };
  },
  methods: {
    toggleModal() {
      this.showNewTopicModal = !this.showNewTopicModal;
    }
  },
  computed: {
    ...mapGetters(["loggedIn"])
  }
};
</script>

<style scoped></style>
